<template>
  <BaseButton
    v-if="!isOnCategoryPage"
    @click="gotoCategory"
    boxShadow="0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
    paddingTop="15px"
    paddingBottom="15px"
    paddingLeft="20px"
    paddingRight="20px"
  >
    <v-icon class="ml-1" color="white" icon="mdi-cursor-default-click" />
    <span class="orders-btn">{{ $t("Header.toOrderSite") }}</span>
  </BaseButton>
</template>

<script>
import BaseButton from "../../UI/BaseButton.vue";
export default {
  components: { BaseButton },
  computed: {
    isOnCategoryPage() {
      return this.$route.name === "Products" || this.$route.name === "CategoryProducts";
    },
  },
  methods: {
    gotoCategory() {
      this.$router.push("/products");
    },
  },
};
</script>

<style></style>
